module.exports = __webpack_public_path__ + "static/media/cancel.d7a23692.svg";